export default {
    title: "Faturas",
    my_invoices: "Minhas Faturas",
    filter_by_date: "Filtrar por data",
    status_label: "Status",
    status_pending: "Aguardando Pagamento",
    status_overdue: "Atrasadas",
    status_paid: "Paga",
    status_cancelled: "Cancelada",
    status_draft: "Rascunho",
    status_overdue_label: "Atrasadas",
    issue_date: "Emissão",
    due_date: "Vencimento",
    payment_date: "Data de Pagamento",
    total_amount: "Valor Total",
    actions: "Ações",
    export: "Exportar",
    add_charge: "Adicionar Cobrança",
    add_charge_subtitle: "Crie negociações extras com parcelamento",
    generate_monthly: "Gerar Faturas Mensais",
    generate_monthly_title: "Gerar faturas mensais",
    generate_monthly_subtitle: "Revise o que será excluído e gerado antes de confirmar.",
    generation_places: "Estabelecimentos",
    generation_to_generate: "A gerar",
    generation_drafts_to_delete: "Rascunhos a excluir",
    generation_blocked: "Mantidas",
    generation_without_plan: "Sem plano",
    generation_selected: "{selected} de {total} selecionadas",
    generation_select_all: "Selecionar todas",
    generation_deselect_all: "Desmarcar todas",
    generation_main_target: "Matriz",
    generation_main_badge: "Matriz",
    generation_running: "Gerando faturas mensais...",
    generation_failed_places: "{count} estabelecimento(s) não puderam ser processados.",
    generation_without_plan_title: "Estabelecimentos ativos sem plano",
    generation_without_plan_hint: "Estes estabelecimentos não terão fatura mensal gerada até que um plano seja vinculado.",
    generation_no_changes: "Nenhuma fatura mensal precisa ser gerada para os ciclos atuais dos planos.",
    generation_confirm: "Gerar faturas",
    generation_preview_error: "Não foi possível carregar a prévia de geração das faturas mensais.",
    generation_execute_error: "Não foi possível gerar as faturas mensais.",
    generation_success: "{generated} fatura(s) gerada(s) e {deleted} rascunho(s) excluído(s).",
    generation_partial_success: "{generated} fatura(s) gerada(s) e {deleted} rascunho(s) excluído(s), mas {failed} estabelecimento(s) ou {syncErrors} problema(s) de sincronização precisam de revisão.",
    establishment: "Estabelecimento",
    branch: "Filial",
    paid_label: "Pago:",
    pay_now: "Pagar agora",
    pay: "Pagar",
    invoice: "Fatura",
    delete_invoice: "Excluir Fatura",
    delete_confirmation: "Tem certeza que deseja excluir esta fatura? Esta ação não pode ser desfeita.",
    cancel: "Cancelar",
    yes_delete: "Sim, excluir",
    attached_bank_slip: "Boleto Anexado",
    available_for_download: "Disponível para download",
    wait_a_moment: "Aguarde um momento",
    drag_pdf_here: "Arraste seu PDF aqui",
    or_click_to_select: "ou clique no botão abaixo para selecionar",
    description: "Descrição",
    add_extra_cost: "Adicionar custo extra",
    invoice_total: "Total da Fatura",
    total_paid: "Total Pago",
    error_loading: "Erro ao carregar fatura",
    bank_slip_available: "Boleto disponível",
    click_to_open_bank_slip: "Clique para abrir o boleto em uma nova aba.",
    add_charge_hint: "Valor cobrado em cada parcela. O total do contrato é este valor multiplicado pelo número de parcelas.",
    not_informed: "Não informado",
    view_details: "Ver Detalhes",
    loading_details: "Carregando detalhes da fatura...",
    load_error_not_found: "Fatura não encontrada ou acesso negado.",
    load_error_general: "Ocorreu um erro ao carregar a fatura. Tente novamente.",
    update_success: "Fatura atualizada com sucesso!",
    view_bank_slip: "Ver boleto",
    bank_slip_unavailable_msg: "O boleto ainda não está disponível. Entre em contato com o suporte.",
    details_back: "Voltar",
    delete_only_draft_error: "Apenas faturas em rascunho podem ser excluídas.",
    delete_only_draft_hint: "Apenas faturas em rascunho podem ser excluídas",
    delete_success: "Fatura excluída com sucesso.",
    delete_confirm_title: "Excluir Fatura",
    filter_status: "Status",
    filter_establishment: "Estabelecimento",
    n_invoices: "{count} faturas",
    cost_breakdown: "Detalhamento de Custos",
    comparing_with: "Comparando com:",
    remove_comparison: "Remover comparação",
    compare: "Comparar",
    no_other_monthly_invoices: "Nenhuma outra fatura mensal disponível",
    loading_invoices: "Carregando faturas...",
    select_invoice: "Selecionar fatura...",
    quantity: "Quantidade",
    value: "Valor",
    total: "Total",
    no_detailed_costs_found: "Nenhum custo detalhado encontrado nesta fatura.",
    no_invoices_found: "Nenhuma fatura encontrada",
    no_invoices_subtitle: "Não há faturas no período selecionado. Tente alterar o filtro de datas.",
    subtotal: "Subtotal",
    interest_fines: "Multas e Juros",
    discount_label: "Desconto",
    comparison_only_monthly_error: "A comparação é suportada apenas para faturas mensais.",
    item_base_plan: "Plano Base",
    item_contacts: "Contatos",
    item_extra_users: "Usuários Extras",
    item_extra_branches: "Filiais Extras",
    item_users: "Usuários",
    item_branches: "Filiais",
    active: "ativos",
    included: "inclusos",
    extra: "extras",
    tooltip_active_users: "Usuários ativos",
    tooltip_included_users: "Usuários inclusos no plano",
    tooltip_extra_users: "Usuários extras que serão cobrados na fatura",
    tooltip_active_branches: "Filiais ativas",
    tooltip_included_branches: "Filiais inclusas no plano",
    tooltip_extra_branches: "Filiais extras que serão cobradas na fatura",
    item_integrations: "Disparadores",
    item_credits: "Créditos",
    item_extra_credits: "Créditos Extras",
    item_incentivized_sales_fee: "Taxa sobre Vendas Incentivadas",
    item_retention_fee: "Taxa sobre Retenção",
    item_cost_adjustment: "Ajuste de Custo",
    item_extra_charge: "Cobrança Extra",
    back_to_invoices: "Voltar para Faturas",
    edit_invoice: "Editar Fatura",
    save_changes: "Salvar Alterações",
    establishment_name: "Nome do estabelecimento",
    cnpj: "CNPJ",
    phone: "Telefone",
    email: "E-mail",
    address: "Endereço",
    complement_short: "Compl.",
    neighborhood: "Bairro",
    city: "Cidade",
    state_short: "UF",
    zip_code_short: "CEP",
    invoice_title: "Título da fatura",
    period_label: "Período:",
    issue_date_label: "Emissão:",
    due_date_label: "Vencimento:",
    attach_bank_slip: "Anexar Boleto",
    internal_notes: "Notas Internas",
    internal_notes_placeholder: "Adicione notas internas sobre esta fatura...",
    internal_notes_hint: "Estas notas são visíveis apenas para a equipe interna.",
    save_notes: "Salvar Notas",
    notes_saved_success: "Notas salvas com sucesso!",
    save_notes_error: "Erro ao salvar as notas internas.",
    slip_compensation_hint: "Pagamentos via boleto podem demorar até 3 dias úteis para serem compensados.",
    change_status_to: "Mudar status para {label}",
    change_status_subtitle: "Você está alterando o status de: {invLabel}. Confirme somente se essa mudança é intencional.",
    change_status_confirm: "Tem certeza que deseja alterar o status desta fatura para \"{label}\"? Esta ação pode impactar o cliente e os registros financeiros.",
    yes_change: "Sim, alterar",
    wait_payment_title: "Aguardar pagamento da fatura",
    wait_payment_subtitle: "{invLabel} — o status passará a \"Aguardando pagamento\".",
    check_bank_slip_hint: "Confirme se o boleto está correto antes de mudar o status.",
    yes_change_status: "Sim, mudar status",
    will_be_cancelled_subtitle: "{invLabel} será marcada como cancelada.",
    cancel_invoice_hint: "Faturas canceladas costumam sair do fluxo de cobrança ativa. Confirme com o financeiro antes de prosseguir.",
    yes_cancel_invoice: "Sim, cancelar fatura",
    will_be_paid_subtitle: "{invLabel} será marcada como paga.",
    mark_as_paid_hint: "Use esta opção apenas quando o pagamento tiver sido efetivamente recebido e conferido.",
    yes_mark_as_paid: "Sim, marcar como pago",
    attach_bank_slip_error: "Para colocar em 'Aguardando Pagamento', você precisa primeiro anexar o boleto da fatura.",
    update_status_error: "Erro ao atualizar o status.",
    update_status_connection_error: "Falha de conexão ao atualizar o status.",
    update_error: "Erro ao salvar as alterações.",
    update_connection_error: "Falha de conexão ao salvar.",
    delete_error: "Erro ao excluir fatura.",
    delete_connection_error: "Falha de conexão ao excluir a fatura.",
    confirm: "Confirmar",
    general: "Geral",
    remove: "Remover",
    loading: "Carregando...",
    invoice_bank_slip: "Boleto da Fatura",
    sending_document: "Enviando documento...",
    select_file: "Selecionar Arquivo",
    upload_bank_slip_hint: "Envie o boleto em formato PDF (máximo 5MB).",
    view_pdf: "Visualizar PDF",
    view: "Ver",
    remove_file: "Remover arquivo",
    remove_bank_slip_title: "Remover Boleto",
    remove_bank_slip_confirm: "Tem certeza que deseja remover o boleto desta fatura?",
    yes_remove: "Sim, remover",
    only_pdf_error: "Apenas arquivos PDF são aceitos.",
    max_size_error: "O arquivo deve ter no máximo 5MB.",
    upload_failure: "Falha ao enviar o boleto.",
    upload_connection_error: "Falha de conexão ao enviar o boleto.",
    remove_failure: "Falha ao remover o boleto.",
    remove_connection_error: "Falha de conexão ao remover o boleto.",
    select_establishment: "Selecione um estabelecimento",
    total_extra_value: "Valor da parcela",
    installments: "Parcelas",
    first_due_date_label: "Primeiro vencimento",
    select_date: "Selecione uma data",
    describe_negotiation: "Descreva a negociação...",
    installments_preview: "Prévia das parcelas",
    installment: "Parcela",
    installments_sum: "Soma das parcelas",
    creating_invoices: "Criando faturas...",
    create_n_invoices: "Criar {n} faturas",
    create_one_invoice: "Criar fatura",
    charge_created_success: "{count} fatura(s) criada(s) com sucesso!",
    create_charge_error: "Erro ao criar cobrança.",
    connection_failure: "Falha de conexão.",
    cancel_invoice: "Cancelar Fatura",
    mark_as_paid: "Marcar como Pago",
    no_changes_to_save: "Nenhuma alteração para salvar.",
    generate_bank_slip: "Gerar Boleto",
    bank_slip_generating: "Gerando boleto...",
    bank_slip_generated_title: "Boleto gerado com sucesso",
    bank_slip_generated_hint: "O pagamento pode levar até 3 dias úteis para ser compensado.",
    bank_slip_view_voucher: "Abrir página do boleto",
    bank_slip_copy_code: "Copiar linha digitável",
    bank_slip_code_copied: "Linha digitável copiada!",
    bank_slip_expires_at: "Vence em",
    bank_slip_generation_error: "Não foi possível gerar o boleto. Tente novamente.",
    bank_slip_missing_tax_id: "CPF/CNPJ não informado na fatura. Atualize os dados de faturamento antes de gerar o boleto.",
    bank_slip_missing_cep: "CEP não informado na fatura. Atualize os dados de faturamento antes de gerar o boleto.",
    bank_slip_generation_success: "Boleto gerado com sucesso!",
    bank_slip_generated_email_sent: "Boleto gerado e e-mail enviado ao financeiro.",
    send_invoice_email: "Enviar por e-mail",
    invoice_email_sent: "E-mail da fatura enviado ao financeiro.",
    invoice_email_failed: "Não foi possível enviar o e-mail da fatura.",
    missing_tax_id_error: "O CPF ou CNPJ do estabelecimento não está informado. Preencha-o no cadastro antes de gerar o boleto.",
    missing_email_error: "O e-mail do estabelecimento não está informado. Preencha-o no cadastro antes de gerar o boleto.",
    missing_cep_error: "O CEP do estabelecimento não está informado. Preencha-o no cadastro antes de gerar o boleto.",
    minimum_amount_error: "O valor mínimo para gerar boleto é de R$ 5,00.",
    gateway_slip_cancel_warning_title: "Atenção: Cancelamento no Gateway",
    gateway_slip_cancel_warning_body: "Este boleto foi gerado automaticamente. Ao removê-lo, a cobrança correspondente no gateway será cancelada e o cliente não conseguirá mais pagá-lo.",
    yes_cancel_and_remove: "Sim, cancelar e remover",
    export: "Exportar",
    export_success: "Faturas exportadas com sucesso!",
    export_error: "Erro ao exportar faturas.",
    invoice_payment_link: "Link de Pagamento",
    payment_link_active_title: "Link de Pagamento Ativo",
    payment_link_active_hint: "Clientes podem pagar com cartão de crédito ou carteiras digitais via Stripe.",
    payment_link_hint: "Gera um link seguro do Stripe Checkout para pagamento com cartão de crédito nacional ou internacional.",
    generate_payment_link: "Gerar Link de Pagamento",
    payment_link_generating: "Gerando link no Stripe...",
    payment_link_generation_success: "Link de pagamento gerado com sucesso!",
    payment_link_generation_error: "Não foi possível gerar o link de pagamento. Tente novamente.",
    payment_link_copy: "Copiar Link",
    payment_link_copied: "Link copiado!",
    payment_link_view: "Abrir Checkout",
    payment_link_remove: "Remover Link",
    payment_link_remove_confirm_title: "Remover Link de Pagamento",
    payment_link_remove_confirm_body: "Tem certeza que deseja remover este link de pagamento? A sessão no Stripe será expirada e não aceitará mais pagamentos.",
    payment_link_remove_success: "Link de pagamento removido com sucesso.",
    payment_link_remove_error: "Erro ao remover o link de pagamento.",
    payment_link_expires_at: "Expira em",
    choose_payment_method: "Escolha como deseja pagar",
    choose_payment_method_subtitle: "Selecione uma das opções de pagamento disponíveis para esta fatura:",
    pay_online_title: "Pagar Online (Cartão de Crédito)",
    pay_online_desc: "Pagamento instantâneo e seguro via Stripe com cartão ou carteiras digitais.",
    pay_online_btn: "Pagar Online",
    pay_slip_title: "Boleto Bancário",
    pay_slip_desc: "Visualizar ou imprimir boleto bancário para pagamento.",
    badge_credit_card: "Cartão de Crédito",
    badge_instant: "Instantâneo",
    badge_bank_slip: "Boleto",
    online_payment_available: "Pagamento Online Disponível",
    click_to_pay_online: "Clique para pagar com cartão de crédito ou carteiras digitais via Stripe.",
    payment_unavailable_msg: "Nenhuma opção de pagamento disponível para esta fatura no momento.",
    credits_whatsapp: "WhatsApp",
    credits_sms: "SMS",
    credits_rcs: "RCS",
    credits_email: "E-mail",
    credits_other: "Outros",
    compare_difference: "Diferença",
    compare_unchanged: "Igual",
    compare_changed_hint: "As linhas em destaque mudaram em relação à fatura comparada.",
    payment_correction_hint: "Corrija juros, multa e o total pago se o valor que entrou no banco estiver diferente."
};
